<script context="module">
    const extData =
        'extId\npaqextMaximo\npaqextOrden\npaqextQuitar\npaqextVisible\npaqextDefault\nextra {\ncost\npromoCost\nprecioSP\npromoCostViX\nextEliminar\nextRequired\nextGrupo\nsubtitle\ntitle\nextName\npromoItem{\ndescripcion\nnombre\nprecio\ntextoComercial}\nopcionesModular{\nplay\naplica\nmonto\n}\ndescriptionOTT\n}';

    export const paqData =
        'paqId\nitemInstalacion\nprecioInstalacion\nboxDetails{detailedSpecs{icon\ndescription}\npromoTextVL\npromoTitle}\ntitle\ncost\ndiscountCost2\npromoCost\nvel\nvisible\ndescription\ndiscountCost\nnombreCode\npromoCode\ncanales\ncanaleshd\nextrasMap{movil2_0{' +
        extData +
        '}\ncanalesCarta{' +
        extData +
        '}\ncanalesPremium{' +
        extData +
        '}\nextensiones{' +
        extData +
        '}\nfacturacion{' +
        extData +
        '}\ngraba{' +
        extData +
        '}\ninternet{' +
        extData +
        '}\nott{' +
        extData +
        '}\ntelefono{' +
        extData +
        '}\ntelefonoExtensiones{' +
        extData +
        '}}\nopcionesModular{\naplica\nmonto\n}\ndisponibleOTT{\nott\naplica}';
</script>
